module.exports = __webpack_public_path__ + "media/images/pool-762813c1.jpg";